import styled from 'styled-components';
import BackgroundImage from  'src/images/EngagementFeaturesBackgroundGradient.png';
import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';

export const FeatureListContainer = styled.div`
  max-width: 100vw !important;
  background-color: ${palette.black};
  position: relative;

  &:before {
    content: " ";
    position: absolute;
    top: -100px;
    z-index: 4;
    left: 0;
    left: 0;
    width: 100%;
    height: 150px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 72.4%, rgba(0, 0, 0, 0) 99.48%);
  }

  @media screen and (max-width: ${layout.lg}) {
    &:before {
      height: 100px;
      top: -65px;
    }
  }

  @media screen and (max-width: ${layout.sm}) {
    &:before {
      height: 190px;
      top: -143px;
    }
  }
`

export const FeatureListContent = styled.div`
  max-width: 1980px;
  box-sizing: border-box;
  padding: 5.5rem 0 7rem;
  margin: 0 auto;
  background: url(${BackgroundImage});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: grid;

  @media screen and (max-width: ${layout.sm}) {
    padding: 2.2rem 0;
    background-size: 150% 100%;
    background-position: -110px;
  }
`

export const HeadSection = styled.div`
  max-width: 1480px;
  justify-self: center;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 4.2rem;
  display: grid;
  grid-row-gap: 2.625rem;

  a {
    font-size: 1.6rem;
    border-radius: 1.1rem;
    font-weight: 900;
    justify-self: center;
  }

  > p {
    max-width: 1100px;
    margin: 0 auto;
    padding: 0 25px;

    strong {
      font-style: italic;
      font-weight: 500;
    }
  }

  @media screen and (max-width: ${layout.sm}) {
    padding: 0 1.3rem;
    grid-row-gap: 2rem;

    > h1 {
      text-align: left;
    }

    > p {
      text-align: left;
      width: 100%;
      padding: 0;
    }

    > a {
      font-size: 1.25rem;
      justify-self: left;
    }
  }
`

export const FeatureListitemsContent = styled.div`
  max-width: 1800px;
  margin: 80px auto 0;
  box-sizing: border-box;
  padding: 0 2.5rem;

  > div {
    display: grid;
    grid-column-gap: 5rem;
  }

  p, h1 {
    color: ${palette.white};
    max-width: 560px;
  }

  @media screen and (max-width: ${layout.subMd}) {
    p, h1 {
      text-align: left;
    }
  }

  @media screen and (max-width: ${layout.sm}) {
    margin-top: 3.75rem;
    padding: 0;

    > div > div:last-child {
      padding: 0 20px;
    }
  }
`
